<template>
  <base-modal v-model:open="isActive" size="larger" hide-footer>
    <template v-slot:button>
      <button
        @click.prevent="toggle"
        class="btn btn-sm ml-2"
      >
        Saiba mais
      </button>
    </template>

    <div class="card-body pt-4 flex flex-col justify-between bg-white">
      <div
        class="absolute top-2 right-4 cursor-pointer"
        @click.prevent="toggle"
      >
        <i class="fas fa-times" style="margin: 0 !important"></i>
      </div>
      <div class="flex justify-center items-center h-full text-white">
        <div class="text-center">
          <h1 class="text-6xl text-blue-500">Uma nova Manycontent</h1>
          <p class="text-blue-500 text-2xl py-8">Há uma versão mais recente da Manycontent disponível.</p>
          <p class="text-gray-800 w-3/4 mx-auto">
            Cada sugestão e feedback dos nossos clientes foi fundamental para reinventarmos a Manycontent. Dedicamos meses de desenvolvimento para criar uma plataforma mais poderosa, intuitiva e alinhada com as demandas do mercado atual.
            <br>
          </p>
          <p class="text-gray-800 w-3/4 mx-auto my-4">
            Descubra <strong class="text-blue-500">todas as novidades </strong> que criamos pensando em você!
          </p>
          <!-- <p class="text-gray-800 w-3/4 mx-auto my-4">Oferta válida até 31/10/24</p> -->
          <button
            @click.prevent="ctaClick"
            class="btn btn-lg mt-8 mx-auto"
            :disabled="isSending"
          >
            Ir para a nova versão
          </button>
        </div>
      </div>
    </div>
  </base-modal>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import BaseModal from '../base/BaseModal.vue';
import localforage from 'localforage';
import { auth } from '@/plugins/firebase';


const MODAL_OPEN_KEY = 'modal_opened_today';

export default defineComponent({
  components: { BaseModal },

  setup () {
    const isSending = ref(false);

    const isActive = ref(false);

    const toggle = () => {
      isActive.value = !isActive.value;
    };

    const isSameDay = (storedDate: string) => {
      const today = new Date().toISOString().split('T')[0];
      return storedDate === today;
    };

    const checkModalStatus = async (): Promise<boolean> => {
      try {
        const storedDate = await localforage.getItem<string>(MODAL_OPEN_KEY);

        if (!storedDate || !isSameDay(storedDate)) {
          await localforage.setItem(MODAL_OPEN_KEY, new Date().toISOString().split('T')[0]);
          return true; // O modal deve ser aberto
        }
      } catch (error) {
        console.error('Erro ao verificar o status do modal:', error);
      }
      return false; // O modal não deve ser aberto
    }

    const openModalIfNeeded = async () => {
      const shouldOpen = await checkModalStatus();
      if (shouldOpen) {
        isActive.value = true;
      }
    };

    const ctaClick = async () => {
      const letsGo = confirm('Você será redirecionado para a nova versão da Manycontent. Deseja continuar?');

      if (letsGo) {
        await localforage.clear()
        window.localStorage.clear()
        await auth.signOut()
        window.location.href = 'https://business.manycontent.com/auth/login'
      }
    }

    onMounted(() => {
      setTimeout(openModalIfNeeded, 5000);
    });

    return {
      isActive,
      isSending,
      toggle,
      ctaClick
    }
  }
})
</script>

<style scoped>
</style>